<template>
    <div class="report-container">
        <h5 class="title">
            {{ $t('reports.dashboards.teamsEvaluations') }}
        </h5>
        <apexchart
            type="bar"
            :series="countBySection"
            :options="chartOptions"
        />
    </div>
</template>

<script>
import evaluationsMixin from './evaluationsMixin'
export default {
    mixins: [evaluationsMixin],
    data() {
        return {
            countBySection: [],
            departmentsNames: [],
            type: 'departments',
        }
    },
    methods: {
        setEvaluationsCount(params) {
            const values = Object.values(params)
            this.departmentsNames = values.map(e => e.sectionName)
            this.countBySection = this.mapDataset(values)
        },
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        borderRadius: 0,
                        barHeight: '70%',
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                labels: this.departmentsNames,
                legend: {
                    show: true,
                    position: 'top',
                    fontSize: '13px',
                    fontFamily: 'Roboto',
                    markers: {
                        width: '15px',
                        height: '15px',
                    },
                },
                colors: Object.values(this.colors),
                grid: {
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: true,
                        },
                    },
                },
                xaxis: {
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: true,
                    },
                },
                yaxis: {
                    labels: {
                        show: true,
                    },
                },
            }
        },
    },
}
</script>
<style lang="sass" src="./default_style.sass" scoped />
